import { render, staticRenderFns } from "./CampaignFollowPreOrdersTab.vue?vue&type=template&id=7f580e00&"
import script from "./CampaignFollowPreOrdersTab.vue?vue&type=script&lang=js&"
export * from "./CampaignFollowPreOrdersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports